<template>
  <div class="q-pa-md full-height">
    <div class="bdr-a-grey-2-lg col-grow q-pa-md">
      <div class="text-paragraph justify-center">
        {{ currentCard }}/{{ numberOfCards }}
      </div>
      <QImg
        :src="cardDetail.img"
        :img-style="{ 'background-size': 'contain' }"
        class="col-12"
        height="120px"
      />

      <h5 class="text-grey-10 text-weight-medium text-left q-mt-sm">
        {{ cardDetail.title }}
      </h5>

      <div class="q-mt-md">
        <div
          class="row"
          v-for="(item, index) in cardDetail.detail"
          :key="index"
        >
          <div class="col-1 q-mr-sm">
            <QIcon :name="item.icon" size="xs" />
          </div>
          <div class="col-10 text-label text-left">
            {{ item.text }}
          </div>
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
import { QImg, QIcon } from 'quasar';

export default {
  name: 'VariantCard',
  props: {
    loading: Boolean,
    disable: Boolean,
    displayFields: Boolean,
    cardDetail: {
      type: Object,
      default: () => ({})
    },
    numberOfCards: Number,
    currentCard: Number
  },
  components: {
    QIcon,
    QImg
  }
};
</script>
